/* eslint-disable import/no-extraneous-dependencies */
import { EditorController } from '@ibiz-template/runtime';
import { ITextBox } from '@ibiz/model-core';
import Alwan from 'alwan';

/**
 * 颜色选择器控制器
 *
 * @author zzq
 * @date 2323-8-14 19:42:00
 * @export
 * @class ColorPickerEditorController
 * @extends {EditorController}
 */
export class ColorPickerEditorController extends EditorController<ITextBox> {
  /**
   * @description 颜色对象
   * @type {Alwan}
   * @memberof ColorPickerEditorController
   */
  public color!: Alwan;

  /**
   * @description 颜色参数
   * @type {IData}
   * @memberof ColorPickerEditorController
   */
  public colorOptions: IData = {};

  /**
   * @description 颜色格式
   * @type {string}
   * @memberof ColorPickerEditorController
   */
  public colorFormat: string = 'hex';

  protected async onInit(): Promise<void> {
    await super.onInit();
    const { coloroptions, colorformat } = this.editorParams;
    if (coloroptions) {
      this.colorOptions = JSON.parse(coloroptions);
    }
    if (colorformat) {
      this.colorFormat = JSON.parse(colorformat);
    }
  }
}
